import { FlexContainer } from "./containers";
import variables from "./variables";
import styled from "styled-components";
import { isMobile } from "../../utils";

export const DriverBasicDetailsContainer = styled.form`
  font-size: 0.875rem;
  #sushi-input {
    margin-bottom: unset;
    height: 3rem;
    input {
      font-size: 0.875rem;
      font-weight: 500;
    }
  }
  &.no-edit {
    #sushi-input input {
      border: unset !important;
      background: unset;
      pointer-events: none;
    }
    #sushi-textarea textarea {
      border: unset !important;
      background: unset;
    }
  }
  #driver-image {
    margin-bottom: unset;
    height: 9rem;
    width: 9rem;
    opacity: ${({ editState }) => (editState ? "0.6" : "1")};
    pointer-events: ${({ editState }) => (editState ? "all" : "none")};
    & > div {
      display: ${({ editState }) => (editState ? "flex" : "none")};
    }
  }
  .city-val,
  .locality-val,
  .zone-val {
    cursor: pointer;
  }
  .city-val input,
  .locality-val input,
  .zone-val input {
    text-decoration: ${({ editState }) => (editState ? "unset" : "underline")};
    color: ${({ editState }) => (editState ? "unset" : variables.primaryColor)};
    cursor: ${({ editState }) =>
      editState ? "unset" : variables.primaryColor};
  }
  .customDropdown {
    margin-bottom: unset;
    font-weight: 500;
    min-height: 3rem;
    pointer-events: ${({ editState }) => (editState ? "all" : "none")};
    border: ${({ editState }) => !editState && "unset"};
    & > div > div {
      display: ${({ editState }) => (editState ? "flex" : "none")};
    }
    background: ${({ editState }) => (editState ? variables.grey100 : "unset")};
  }
  .MuiInputBase-root {
    background: ${({ editState }) => (editState ? variables.grey100 : "unset")};
  }
  .calender-input {
    input {
      &::-webkit-calendar-picker-indicator {
        display: ${({ editState }) => (!editState ? "none" : "block")};
        -webkit-appearance: ${({ editState }) =>
          !editState ? "none" : "block"};
      }
    }
  }
  .containsDropdown {
    .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon
      .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
      border-radius: 8px;
      padding: 10px 18px;
      box-sizing: border-box;
      margin-bottom: unset;
      height: unset;
    }
    .Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${variables.grey300};
    }
    .MuiFormLabel-root.Mui-focused {
      color: ${variables.grey700};
    }
    .MuiAutocomplete-popupIndicator {
      margin-right: 8px;
    }
    .cross {
      opacity: 0.5;
      width: 15px;
      height: auto;
      margin-right: 10px;
    }
    .MuiInputLabel-outlined {
      transform: translate(20px, 15px) scale(1);
      &.MuiInputLabel-shrink {
        transform: translate(10px, -8px) scale(0.8);
      }
    }
    .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]
      .MuiAutocomplete-input {
      padding: 8px 4px;
    }
  }
  sup {
    color: ${variables.primaryColor};
    font-size: 1rem;
    margin-top: 4px;
  }
  .note-field {
    color: ${variables.primaryColor};
  }
  .MuiAutocomplete-root {
    width: 100% !important;
    margin-bottom: unset;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    pointer-events: ${({ editState }) => (editState ? "all" : "none")};
  }
  .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]
    .MuiAutocomplete-endAdornment {
    display: ${({ editState }) => (!editState ? "none" : "block")};
  }
  .MuiOutlinedInput-notchedOutline {
    border: ${({ editState }) => !editState && "unset"};
  }
  .redirect-icon {
    & > svg {
      width: 15px;
      height: 15px;
    }
  }
`;

export const FieldHolder = styled.div`
  padding: 1.125rem 0;
  display: ${({ display }) => display || "flex"};
  align-items: ${(props) => (props.align ? props.align : "center")};
  justify-content: ${(props) =>
    props.justify ? props.justify : "space-between"};
  grid-template-columns: ${({ repeat }) =>
    `repeat(${repeat || 2}, minmax(0, 1fr))`};
  column-gap: ${isMobile() ? "0.2rem" : "1rem"};
  &:not(:last-child) {
    border-bottom: ${({ noBorder }) =>
      noBorder ? "unset" : `1px solid ${variables.grey200}`};
  }
  span {
    flex: 0 1 30%;
    color: ${variables.grey500};
    margin-right: 0.6rem;
    font-weight: 500;
  }
`;
